module.exports = __webpack_public_path__ + "img/icon 6@3x.1dedae98.png";